/** 请求接口文档
 *  无正式数据请求mock
 */
export default {
    QueryItems:"/api/category/worker/item/QueryItems", // 初始化列表
    Save:"/api/category/worker/item/Save", // 保存信息
    GetItem:"/api/category/worker/item/GetItem", //
    QueryMiceWorkers:"/api/category/worker/Staffs/QueryMiceWorkers", //获取人员列表
    Cancel:"/api/category/worker/item/Cancel", // 取消
    QueryCostDetails:"/api/category/worker/Expense/QueryCostDetails", // 确认结算页面初始化
    GetBudgetProject:"/api/category/worker/Item/GetBudgetProject", // 预算项目
    GetWorkerTypes:"/api/category/worker/Item/GetWorkerTypes", // 人员类型
    ExpenseTask:"/api/category/worker/Expense/ExpenseTask", // 确认结算
    ProcessTask: "api/foundation/workflow/FnFlowTask/ProcessTask"
}





// WEBPACK FOOTER //
// ./src/api/api.js